import ApiHandler from './ApiHandler';

export default {
    follow: followingUserId => ApiHandler.post('/follow', { followingUserId }),
    unfollow: unfollowingUserId =>
        ApiHandler.delete(`/follow/${unfollowingUserId}`)
};
